import * as universal_hooks from '../../../src/hooks.ts';

export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23')
];

export const server_loads = [];

export const dictionary = {
		"/(kiosk)": [21,[8]],
		"/auth/callback": [23],
		"/(admin)/chat": [9,[2]],
		"/(admin)/dashboard": [10,[2]],
		"/(anonymous)/invoices/[token]": [20,[6,7]],
		"/(admin)/kiosks": [11,[2]],
		"/(admin)/kiosks/[id]": [12,[2,3]],
		"/(kiosk)/maintenance": [22,[8]],
		"/(admin)/parking-lots": [13,[2]],
		"/(admin)/parking-service-companies": [14,[2]],
		"/(admin)/parking-service-companies/create": [16,[2]],
		"/(admin)/parking-service-companies/[id]": [15,[2,4]],
		"/(admin)/settings": [17,[2]],
		"/(admin)/transactions": [18,[2]],
		"/(admin)/transactions/[id]": [19,[2,5]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: universal_hooks.reroute || (() => {}),
	transport: universal_hooks.transport || {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';